import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
// import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'

import {useAuth} from "../modules/auth";

const PrivateRoutes = () => {
    const {currentUser} = useAuth();
    const AdminPage = lazy(()=>import('../pages/Admin/AdminPage'))
    const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
    // const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
    const DiskPage = lazy(() => import('../pages/disk/DiskPage'))
    const TikaPage = lazy(()=>import('../pages/tikets/TikaPage'))

    const CostumerPage = lazy(()=>import('../pages/custumers/CustumerPage'))
    const ManufacturyPage = lazy(()=>import('../pages/manufacurs/ManufacturyPage'))
    const ListPage = lazy(()=>import('../pages/lists/ListPage'))


    return (
        <Routes>
            <Route element={<MasterLayout/>}>
                {/* Redirect to Dashboard after success login/registartion */}
                <Route path='auth/*' element={<Navigate to='/crafted/account/overview'/>}/>
                {/* Pages */}
                {/*<Route path='builder' element={<BuilderPageWrapper/>}/>*/}
                {/*<Route path='menu-test' element={<MenuTestPage/>}/>*/}

                {/* Lazy Modules */}
                {currentUser?.roles?.includes('Admin') === true && (
                    <>
                        <Route path='dashboard' element={<DashboardWrapper/>}/>

                        <Route
                            path="Admin/*"
                            element={
                                <SuspensedView>
                                    <AdminPage/>
                                </SuspensedView>
                            }
                        />
                    </>
                )}

                {/*<Route*/}
                {/*    path='crafted/widgets/*'*/}
                {/*    element={*/}
                {/*        <SuspensedView>*/}
                {/*            <WidgetsPage/>*/}
                {/*        </SuspensedView>*/}
                {/*    }*/}
                {/*/>*/}
                <Route
                    path='crafted/account/*'
                    element={
                        <SuspensedView>
                            <AccountPage/>
                        </SuspensedView>
                    }
                />

                <Route
                    path='apps/Costumer-management/*'
                    element={
                        <SuspensedView>
                            <CostumerPage/>
                        </SuspensedView>
                    }
                />
                <Route
                    path='apps/manufacury/*'
                    element={
                        <SuspensedView>
                            <ManufacturyPage/>
                        </SuspensedView>
                    }
                />
                <Route
                    path='Disk/*'
                    element={
                        <SuspensedView>
                            <DiskPage/>
                        </SuspensedView>
                    }
                />

                <Route
                    path='list/*'
                    element={
                        <SuspensedView>
                            <ListPage/>
                        </SuspensedView>
                    }
                />
                <Route
                    path='Tickets/*'
                    element={
                        <SuspensedView>
                            <TikaPage/>
                        </SuspensedView>
                    }
                />

                {/* Page Not Found */}
                <Route path='*' element={<Navigate to='/error/404'/>}/>
            </Route>
        </Routes>
    )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
    const baseColor = getCSSVariableValue('--kt-primary')
    TopBarProgress.config({
        barColors: {
            '0': baseColor,
        },
        barThickness: 1,
        shadowBlur: 5,
    })
    return <Suspense fallback={<TopBarProgress/>}>{children}</Suspense>
}

export {PrivateRoutes}
